import {
 Outlet
} from 'react-router-dom';

const DataBuilderPage: React.FC = () => {
    return (
        <Outlet />
    );
};

export default DataBuilderPage;
